export const faq = {
  title: 'Soalan Lazim',
  subtitle: 'Cari jawapan kepada soalan lazim tentang MakanTak',
  backToHome: 'Kembali ke Laman Utama',
  stillHaveQuestions: 'Masih ada soalan?',
  stillHaveQuestionsDesc: 'Tidak jumpa jawapan yang anda cari? Pasukan sokongan kami sedia membantu!',
  contactSupport: 'Hubungi Sokongan',
  
  q1: 'Apakah MakanTak?',
  a1: 'MakanTak adalah platform diskaun rujukan viral yang memberi ganjaran kepada anda kerana berkongsi dengan rakan. Apabila anda merujuk seseorang dan mereka membuat pembelian, anda memperoleh mata wang virtual yang boleh digunakan sebagai diskaun pada lawatan seterusnya!',
  
  q2: 'Bagaimana saya memperoleh mata wang virtual?',
  a2Title: 'Anda memperoleh mata wang virtual dalam dua cara:',
  a2Point1: 'Diskaun terjamin 5% pada pembelian pertama anda',
  a2Point2: '1% daripada setiap pembelian yang dibuat oleh orang yang anda rujuk (sehingga 3 peringkat)',
  a2Example: 'Contohnya: Jika rakan anda berbelanja RM100, anda memperoleh RM1. Jika rakan mereka berbelanja RM100, anda juga memperoleh RM1!',
  
  q3: 'Bagaimana saya berkongsi kod rujukan saya?',
  a3: 'Pergi ke papan pemuka anda dan tekan butang \'Kongsi\'. Anda boleh berkongsi kod QR unik atau pautan anda melalui WhatsApp, Facebook, atau mana-mana aplikasi pemesejan. Apabila seseorang mendaftar menggunakan pautan anda, mereka menjadi downline anda!',
  
  q4: 'Apakah diskaun maksimum yang boleh saya gunakan?',
  a4: 'Anda boleh menebus sehingga 20% daripada jumlah bil anda menggunakan mata wang virtual. Contohnya, pada bil RM100, anda boleh menggunakan sehingga RM20 daripada baki mata wang virtual anda.',
  
  q5: 'Adakah mata wang virtual saya luput?',
  a5: 'Ya, mata wang virtual luput 30 hari selepas anda memperolehnya. Anda akan menerima pemberitahuan e-mel 7 hari sebelum tamat tempoh untuk mengingatkan anda menggunakannya. Pastikan anda memeriksa baki anda dengan kerap!',
  
  q6: 'Bolehkah saya menggabungkan diskaun?',
  a6: 'Ya! Diskaun terjamin 5% kali pertama anda akan digunakan secara automatik, dan anda juga boleh menebus mata wang virtual (sehingga 20% daripada bil) di atas itu.',
  
  q7: 'Berapa banyak peringkat rujukan yang boleh saya perolehi?',
  a7: 'Anda memperoleh daripada sehingga 3 peringkat rujukan. Peringkat 1 adalah orang yang anda rujuk secara langsung, Peringkat 2 adalah orang yang mereka rujuk, dan Peringkat 3 adalah orang yang dirujuk oleh Peringkat 2. Setiap peringkat memberi anda 1% daripada pembelian mereka.',
  
  q8: 'Bagaimana saya menebus mata wang virtual saya?',
  a8: 'Hanya tunjukkan kod QR anda kepada kakitangan semasa membayar. Mereka akan mengimbas dan anda boleh memilih berapa banyak mata wang virtual untuk ditebus (sehingga 20% daripada bil anda). Diskaun digunakan serta-merta!',
  
  q9: 'Adakah data peribadi saya selamat?',
  a9: 'Ya! Kami mematuhi Akta Perlindungan Data Peribadi (PDPA) 2010 Malaysia. Kami hanya mengumpul maklumat yang diperlukan dan tidak berkongsi data anda dengan pihak ketiga tanpa kebenaran.',
  a9Link: 'Baca Dasar Privasi penuh kami untuk butiran lanjut.',
  
  q10: 'Bolehkah saya menggunakan mata wang virtual saya di mana-mana restoran?',
  a10: 'Pada masa ini, mata wang virtual adalah khusus untuk restoran di mana anda memperolehnya. Setiap restoran mempunyai program rujukan sendiri.',
  
  q11: 'Apa yang berlaku jika saya terlupa kata laluan saya?',
  a11: 'Klik \'Lupa Kata Laluan\' di halaman log masuk. Kami akan menghantar pautan tetapan semula kata laluan melalui e-mel. Ikuti pautan untuk mencipta kata laluan baharu.',
  
  q12: 'Bolehkah saya menukar tarikh lahir atau e-mel saya?',
  a12: 'Atas sebab keselamatan, tarikh lahir dan e-mel tidak boleh ditukar secara langsung. Sila hubungi pasukan sokongan kami jika anda perlu mengemaskini butiran ini.',
  
  q13: 'Mengapa saya perlu memberikan tarikh lahir saya?',
  a13: 'Kami memerlukan tarikh lahir anda untuk mengesahkan anda berumur 18 tahun ke atas (keperluan umur undang-undang) dan untuk menghantar tawaran istimewa hari lahir!',
  
  q14: 'Bagaimana saya memadam akaun saya?',
  a14: 'Untuk memadam akaun anda dan semua data yang berkaitan, sila hubungi pasukan sokongan kami di support@makantak.com',
  a14Note: 'Nota: Memadam akaun anda akan membuang semua baki mata wang virtual dan sejarah rujukan anda.',
  
  q15: 'Bolehkah saya memindahkan mata wang virtual saya kepada orang lain?',
  a15: 'Tidak, mata wang virtual tidak boleh dipindahkan dan hanya boleh digunakan oleh pemegang akaun yang memperolehnya.',
  
  q16: 'Bagaimana jika pengimbas kod QR tidak berfungsi?',
  a16: 'Jika pengimbas QR mengalami masalah, kakitangan boleh memasukkan kod rujukan anda secara manual. Kod anda dipaparkan di bawah kod QR anda di papan pemuka.',
};

export const about = {
  title: 'Tentang MakanTak',
  subtitle: 'Merevolusikan kesetiaan restoran melalui rujukan viral',
  backToHome: 'Kembali ke Laman Utama',
  
  missionTitle: 'Misi Kami',
  missionText: 'Untuk memperkasakan restoran dan pelanggan melalui sistem rujukan menang-menang yang memberi ganjaran perkongsian, membina komuniti, dan menjadikan makan di luar lebih berpatutan untuk semua orang.',
  
  whatWeDoTitle: 'Apa Yang Kami Lakukan',
  whatWeDoPara1: 'MakanTak adalah platform diskaun rujukan viral pertama Malaysia yang direka khusus untuk restoran. Kami membantu restoran mengembangkan pangkalan pelanggan mereka secara organik sambil memberi ganjaran kepada pelanggan setia kerana menyebarkan berita.',
  whatWeDoPara2: 'Tidak seperti program kesetiaan tradisional yang hanya memberi ganjaran pembelian individu, MakanTak mencipta kesan rangkaian di mana semua orang mendapat manfaat. Apabila anda berkongsi kod rujukan anda dan rakan anda makan di restoran, anda memperoleh mata wang virtual. Apabila rakan mereka makan, anda memperoleh lagi - sehingga 3 peringkat!',
  
  coreValuesTitle: 'Nilai Teras Kami',
  transparencyTitle: 'Ketelusan',
  transparencyDesc: 'Peraturan yang jelas, pendapatan yang boleh dilihat, dan komunikasi yang jujur. Anda sentiasa tahu berapa banyak yang anda peroleh dan bila ia luput.',
  communityTitle: 'Komuniti',
  communityDesc: 'Membina hubungan melalui makanan. Setiap rujukan mengukuhkan komuniti dan membantu restoran tempatan berkembang maju.',
  growthTitle: 'Pertumbuhan',
  growthDesc: 'Menang-menang untuk semua orang. Restoran memperoleh pelanggan secara organik, dan pelanggan menjimatkan wang sambil berkongsi pengalaman makanan yang hebat.',
  simplicityTitle: 'Kesederhanaan',
  simplicityDesc: 'Mudah digunakan untuk semua orang. Kongsi kod, peroleh ganjaran, tebus diskaun. Tiada peraturan rumit atau terma tersembunyi.',
  
  howItWorksTitle: 'Bagaimana Ia Berfungsi',
  step1Title: 'Daftar & Dapatkan Kod Anda',
  step1Desc: 'Cipta akaun percuma anda dan terima kod rujukan unik dan kod QR dengan serta-merta.',
  step2Title: 'Kongsi Dengan Rakan',
  step2Desc: 'Kongsi kod anda melalui WhatsApp, Facebook, atau mana-mana aplikasi pemesejan. Rakan anda mendapat diskaun 5% pada lawatan pertama mereka!',
  step3Title: 'Peroleh Secara Automatik',
  step3Desc: 'Apabila rujukan anda makan, anda secara automatik memperoleh 1% daripada bil mereka sebagai mata wang virtual - sehingga 3 peringkat!',
  step4Title: 'Tebus & Jimat',
  step4Desc: 'Gunakan mata wang virtual anda untuk mendapat sehingga 20% diskaun pada hidangan seterusnya. Tunjukkan kod QR anda dan jimat serta-merta!',
  
  forRestaurantsTitle: 'Untuk Pemilik Restoran',
  forRestaurantsPara: 'MakanTak membantu anda memperoleh pelanggan baharu pada sebahagian kecil daripada kos pemasaran tradisional. Daripada berbelanja untuk iklan, anda memberi ganjaran kepada pelanggan yang membawa rakan mereka.',
  forRestaurantsPoint1: 'Pertumbuhan organik melalui pemasaran dari mulut ke mulut',
  forRestaurantsPoint2: 'Papan pemuka analitik masa nyata untuk menjejak prestasi',
  forRestaurantsPoint3: 'Pengiraan diskaun automatik dan pengurusan mata wang virtual',
  forRestaurantsPoint4: 'Cerapan pelanggan dan alat segmentasi',
  partnerWithUs: 'Bekerjasama Dengan Kami',
  
  questionsTitle: 'Soalan atau Maklum Balas?',
  questionsDesc: 'Kami ingin mendengar daripada anda! Sama ada anda pelanggan atau pemilik restoran, hubungi kami.',
  viewFAQ: 'Lihat Soalan Lazim',
  contactUs: 'Hubungi Kami',
};

export const contact = {
  title: 'Hubungi Kami',
  subtitle: 'Kami di sini untuk membantu! Hubungi kami dengan sebarang soalan atau maklum balas.',
  backToHome: 'Kembali ke Laman Utama',
  
  emailSupportTitle: 'Sokongan E-mel',
  emailSupportDesc: 'Untuk pertanyaan am dan sokongan',
  emailSupportAddress: 'support@makantak.com',
  
  businessInquiriesTitle: 'Pertanyaan Perniagaan',
  businessInquiriesDesc: 'Perkongsian restoran dan kerjasama',
  businessInquiriesAddress: 'support@makantak.com',
  
  sendMessageTitle: 'Hantar Mesej Kepada Kami',
  nameLabel: 'Nama Anda',
  namePlaceholder: 'Ahmad Ali',
  emailLabel: 'Alamat E-mel',
  emailPlaceholder: 'ahmad@example.com',
  subjectLabel: 'Subjek',
  subjectPlaceholder: 'Pilih subjek',
  subjectGeneral: 'Pertanyaan Am',
  subjectSupport: 'Sokongan Teknikal',
  subjectAccount: 'Isu Akaun',
  subjectPartnership: 'Perkongsian Restoran',
  subjectFeedback: 'Maklum Balas',
  subjectOther: 'Lain-lain',
  messageLabel: 'Mesej',
  messagePlaceholder: 'Beritahu kami bagaimana kami boleh membantu...',
  sendButton: 'Hantar Mesej',
  sending: 'Menghantar...',
  
  noteTitle: 'Nota:',
  noteText: 'Kami biasanya membalas dalam masa 24-48 jam pada hari bekerja. Untuk perkara mendesak, sila hubungi talian sokongan kami.',
  
  quickLinksTitle: 'Sebelum menghubungi kami, anda mungkin jumpa jawapan di sini:',
  faqTitle: 'Soalan Lazim',
  faqDesc: 'Soalan lazim',
  aboutTitle: 'Tentang Kami',
  aboutDesc: 'Ketahui lebih lanjut tentang MakanTak',
  privacyTitle: 'Dasar Privasi',
  privacyDesc: 'Bagaimana kami melindungi data anda',
  
  messageSent: 'Mesej berjaya dihantar! Kami akan menghubungi anda tidak lama lagi.',
  messageFailed: 'Gagal menghantar mesej. Sila cuba lagi atau e-mel kami secara langsung.',
  fillAllFields: 'Sila isi semua medan',
};
